import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import config, { servicePlansEnum } from './servicePlanConfig';

import './ServicePlanBody.scss';

const ServicePlanBody = ({ servicePlan }) => {
  const servicePlanBodyCx = classNames(
    'service-plan-body',
    `service-plan-body--${servicePlan}`
  );

  const renderFeatureItem = item => (
    <li className="service-plan-body__feature-item" key={item.nameKey}>
      <item.icon colour={item.iconColour} />
      <span className="service-plan-body__feature-name">
        {trans(item.nameKey)}
      </span>
    </li>
  );

  return (
    <div className={servicePlanBodyCx}>
      <ul className="service-plan-body__feature-list">
        {config[servicePlan].featureList.map(featureItem =>
          renderFeatureItem(featureItem)
        )}
      </ul>
    </div>
  );
};

ServicePlanBody.propTypes = {
  servicePlan: PropTypes.oneOf(Object.values(servicePlansEnum)).isRequired
};

export default ServicePlanBody;
